import React from "react"
import Tag, {TagTheme} from "../Tag/Tag"
import AccordionList from "../AccordionList/AccordionList"
import {ReasonCode, ReasonCodes as ReasonCodesType} from "../../resources/application"

interface Props {
	data: Array<{name: string; items: ReasonCodesType}>
}

export default function ReasonCodes({data}: Props) {
	const riskCodesItems = data.map(({name, items}) => {
		return {
			title: name,
			content: (
				<ul key={name} className="reason-codes">
					{Object.entries(items).map(([key, {riskCodes, informationalCodes}]) => {
						const reasonCodes: Array<{title: string; codes?: ReasonCode[]; theme: TagTheme}> = [
							{title: "Risk Codes", codes: riskCodes, theme: "error"},
							{title: "Informational Codes", codes: informationalCodes, theme: "info"},
						]

						const updatedKey = key.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase()

						return (
							<li key={key}>
								<h3>{updatedKey === "kyc" ? "KYC" : updatedKey}</h3>
								{reasonCodes.map(({title, codes, theme}) => {
									return (
										codes && (
											<div className="reason-code-item" key={`${key}-${title}`}>
												<p>{title}:</p>
												<ul>
													{codes?.map(({code, description}) => (
														<li key={code}>
															<Tag theme={theme} variant="filled" content={code} size="small" /> <p>{description}</p>
														</li>
													))}
												</ul>
											</div>
										)
									)
								})}
							</li>
						)
					})}
				</ul>
			),
		}
	})

	return <AccordionList theme="full" title="Reason Codes" items={riskCodesItems} />
}
